import { IAttrValue } from "@multiweb/types/contracts";

/**
 * Představuje šifrovanou hodnotu atributu aplikačního objektu spolu s dalšími informacemi.
 * @includeToDoc
 */
export interface IEncAttrValue extends IAttrValue {
    /**
     * Zda obsahuje právě zašifrovanou nebo rozšifrovanou hodnotu
     */
    readonly isEncrypted: boolean;

    /**
     * True, pokud atribut obsahuje zašifrovanou hodnotu.
     */
    readonly hasEncryptedValue: boolean;

    /**
     * Dešifruje hodnotu atributu předaným klíčem a pomocí deserializeru ji převede na původní datový typ
     * @param key Dešifrovací klíč
     * @returns True pokud se povedlo dešifrovat nebo to nebylo třeba, jinak false
     */
    decrypt(key: CryptoKey): Promise<boolean>;
}

export class IEncAttrValue {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && typeof instance === "object" &&
            Reflect.has(instance, "isEncrypted") &&
            Reflect.has(instance, "decrypt");
    }
}

/** Představuje řetězcovou hodnotu atributu aplikačního objektu. */
export interface IAttrStringValue extends IAttrValue {
    /**
     * Příznak indikující, že se jedná o zkrácenou hodnotu atributu.
     */
    shortened: boolean;
}

export class IAttrStringValue {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && typeof instance === "object" &&
            Reflect.has(instance, "shortened");
    }
}
